import { render, staticRenderFns } from "./UnsubscriberEmailPage.vue?vue&type=template&id=64b90d39&scoped=true&"
import script from "./UnsubscriberEmailPage.vue?vue&type=script&lang=js&"
export * from "./UnsubscriberEmailPage.vue?vue&type=script&lang=js&"
import style0 from "./UnsubscriberEmailPage.vue?vue&type=style&index=0&id=64b90d39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b90d39",
  null
  
)

export default component.exports